import React, { useEffect } from 'react';

const Screensaver = () => {
    useEffect(() => {
        // Crear el contenido HTML del screensaver
        const htmlContent = `
            <!DOCTYPE html>
            <html lang="en">
            <head>
              <meta charset="UTF-8">
              <title>Iris Out Fullscreen</title>
              <style>
                html, body {
                  margin: 0;
                  padding: 0;
                  height: 100%;
                  background-color: #000;
                  overflow: hidden;
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  position: relative;
                }

                #lolButton {
                  padding: 20px 40px;
                  font-size: 24px;
                  background-color: white;
                  color: #2196f3;
                  border: none;
                  border-radius: 30px;
                  cursor: pointer;
                  z-index: 3;
                  position: relative;
                  transition: opacity 0.3s ease-out 0.6s;    
                }

                #lolButton.fade-out {
                  opacity: 0;
                }

                #irisOverlay {
                  position: fixed;
                  top: 0;
                  left: 0;
                  width: 100vw;
                  height: 100vh;
                  background: #2196f3;
                  z-index: 2;
                  pointer-events: none;
                  clip-path: circle(100% at center);
                  transition: clip-path 1s ease-out;
                }

                #irisOverlay.iris-close {
                  clip-path: circle(0% at center);
                  pointer-events: auto;
                }

                #lolButton.hide {
                  display: none;
                }
              </style>
            </head>
            <body>
              <div id="irisOverlay"></div>
              <button id="lolButton">LOL</button>

              <script>
                const lolButton = document.getElementById('lolButton');
                const irisOverlay = document.getElementById('irisOverlay');

                lolButton.addEventListener('click', async () => {
                  irisOverlay.classList.add('iris-close');   
                  lolButton.classList.add('fade-out');       

                  setTimeout(async () => {
                    if (document.documentElement.requestFullscreen) {
                      await document.documentElement.requestFullscreen();
                    } else if (document.documentElement.webkitRequestFullscreen) {
                      await document.documentElement.webkitRequestFullscreen();
                    }

                    lolButton.classList.add('hide');
                    lolButton.classList.remove('fade-out');  
                  }, 1000);
                });

                // Allow exiting fullscreen with click or spacebar
                document.addEventListener('click', () => {   
                  if (document.fullscreenElement || document.webkitFullscreenElement) {
                    document.exitFullscreen?.() || document.webkitExitFullscreen?.();
                  }
                });

                document.addEventListener('keydown', (e) => {
                  if (e.code === 'Space') {
                    e.preventDefault();
                    if (document.fullscreenElement || document.webkitFullscreenElement) {
                      document.exitFullscreen?.() || document.webkitExitFullscreen?.();
                    }
                  }
                });

                // Handle fullscreen exit (including ESC)    
                document.addEventListener('fullscreenchange', () => {
                  if (!document.fullscreenElement) {
                    irisOverlay.classList.remove('iris-close');
                    lolButton.classList.remove('hide');      
                  }
                });

                // Safari support
                document.addEventListener('webkitfullscreenchange', () => {
                  if (!document.webkitFullscreenElement) {   
                    irisOverlay.classList.remove('iris-close');
                    lolButton.classList.remove('hide');      
                  }
                });
              </script>
            </body>
            </html>
        `;

        // Crear un blob y establecer el iframe
        const blob = new Blob([htmlContent], { type: 'text/html' });
        const url = URL.createObjectURL(blob);
        
        const iframe = document.createElement('iframe');
        iframe.src = url;
        iframe.style.cssText = `
            border: none;
            width: 100%;
            height: 100%;
            display: block;
        `;
        
        const container = document.getElementById('screensaver-container');
        if (container) {
            container.appendChild(iframe);
        }

        return () => {
            URL.revokeObjectURL(url);
        };
    }, []);

    return (
        <div 
            id="screensaver-container" 
            style={{
                width: '100vw',
                height: '100vh',
                margin: 0,
                padding: 0,
                overflow: 'hidden',
                display: 'block'
            }}
        />
    );
};

export default Screensaver;
